import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66ffc06e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../selectTable/index.css?vue&type=style&index=0&id=66ffc06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffc06e",
  null
  
)

export default component.exports